import { render, staticRenderFns } from "./safety-card.vue?vue&type=template&id=59ee6140&scoped=true"
import script from "./safety-card.vue?vue&type=script&lang=js"
export * from "./safety-card.vue?vue&type=script&lang=js"
import style0 from "./safety-card.vue?vue&type=style&index=0&id=59ee6140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ee6140",
  null
  
)

export default component.exports